import styled from 'styled-components'
import {GHOST_GRAY, PERMISSION_RED, RIBBON_BLUE, WHITE} from 'constants/colors'

const InputHolder = styled.div`
  border: 1px solid ${GHOST_GRAY};
  width: max-content;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  background-color: ${WHITE};
  margin-right: 10px;
  padding: 10px;
  max-height: 45px;
  min-width: 100%;
  position: relative;
  margin-bottom: 20px;
`

const Input = styled.input`
  padding: 10px;
  border: none;
  outline: none;
  width: 90%;
  border-radius: 5px;
  font-size: 14px;
  line-height: 19px;
  background-color: ${WHITE};
  color: ${RIBBON_BLUE};
`

const Enter = styled.div`
  width: 6%;
  cursor: pointer;
`

const Alert = styled.div`
  color: ${PERMISSION_RED};
  font-size: 12px;
  position: absolute;
  bottom: -20px;
`

const UserSaysWrapper = styled.div`
  max-height: 175px;
  overflow: auto;
`

export { InputHolder, Input, Enter, Alert, UserSaysWrapper }
